import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import WhatsAppOpt from '@quikr/ui/src/common/WhatsAppOpt';
import { Typography, Button, SvgComponent } from '@quikr/ui';
import jobsCallSprite from '@quikr/ui/src/assets/jobs-call-sprite.svg';
import { returnUsableUser, apiWrapper } from '../helpers/common';

const ContactWrapper = styled.div`
  padding: 9px 0 0;
  @media screen and (min-width: 768px) {
    padding: 6px 0 22px;
  }
`;

const Text = styled(Typography)`
  color: ${({ theme }) => theme.colors.TextAlpha};
  margin: 40px 0 20px;
  @media screen and (min-width: 768px) {
    margin: 40px 45px 20px;
  }
`;

const ContactInfoWrap = styled.div`
  margin-bottom: 30px;
  padding-left: 9px;
  @media screen and (min-width: 768px) {
    justify-content: center;
    padding-left: 0;
  }
`;

const ContactInfo = styled.div`
  text-align: left;
  min-width: 40%;
  div {
    margin-bottom: 2px;
  }
  a {
    color: ${props => props.theme.colors.Primary};
    font-weight: 700;
  }
  span {
    font-weight: 700;
  }
`;

const Icon = styled(SvgComponent)`
  width: 30px;
  height: 30px;
  margin-right: 18px;
  @media screen and (min-width: 768px) {
    width: 40px;
    height: 40px;
    margin-right: 25px;
  }
`;

const ViewContact = props => {
  const {
    recruiter,
    stepTwo,
    id,
    role,
    user,
    storeCallData,
    action,
    isVIP,
    changeView,
    close,
    skipStepTwo,
    setActionState,
    fireGa,
    getStep2DetailsRequest
  } = props;
  const [whatsappOptInFlag, SetWhatsappOptInFlag] = useState(false);
  const getDetails = async () => {
    const response = await getStep2DetailsRequest({
      variables: {
        createPayload: {
          ad: {
            id: parseInt(id),
            role: role
          },
          user: returnUsableUser(user)
        }
      }
    });
    const data = response.data;
    if (data && data.getStep2Details && data.getStep2Details.step_2_form) {
      storeCallData(data.getStep2Details);
    }
  };

  const subscribeToWhatsapp = () => {
    if (whatsappOptInFlag) {
      apiWrapper({
        // eslint-disable-next-line no-undef
        url: `${__WP_CLIENT_GQL_ENDPOINT}/o/notification/subscribeToWhatsapp`,
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: {
          mobile: user.mobile,
          vertical: 'jobs'
        }
      });
    }
  };

  const showNextStep = () => {
    if (!stepTwo || !stepTwo.length === 0) {
      getDetails();
    } else {
      storeCallData();
    }
    subscribeToWhatsapp();
    fireGa && fireGa('contactRecruiterModal_step2_continue');
  };
  const doneAction = () => {
    if (skipStepTwo) {
      setActionState({ action: 'COMPLETED_STEPONE', status: true });
    }
    isVIP ? close() : changeView('promotion');
    subscribeToWhatsapp();
  };
  useEffect(() => {
    recruiter && fireGa && fireGa('contactRecruiterModal_step2_contactViewed');
  }, []);
  return (
    <ContactWrapper className="taC">
      {recruiter && recruiter.mobile ? (
        <>
          <ContactInfoWrap className="dFA">
            <Icon svgSprite={jobsCallSprite} id="jobs_call"></Icon>
            <ContactInfo>
              <div>Recruiter&apos;s number</div>
              <a href={`tel:+91${recruiter.mobile}`}>{recruiter.mobile}</a>
            </ContactInfo>
          </ContactInfoWrap>
          <ContactInfoWrap className="dFA">
            <Icon svgSprite={jobsCallSprite} id="jobs_clock"></Icon>
            <ContactInfo>
              <div>Common office hours</div>
              <span>10AM - 6PM</span>
            </ContactInfo>
          </ContactInfoWrap>
        </>
      ) : (
        recruiter &&
        recruiter.error && (
          <Text className="form__heading" tagName="p">
            {recruiter.error.description}
          </Text>
        )
      )}

      {action !== 'COMPLETED_STEPTWO' && !skipStepTwo ? (
        <>
          <Text className="form__heading" tagName="p">
            Please fill more details to <b>3x responses</b> for your application
          </Text>
          <WhatsAppOpt onChange={(e, fieldState) => SetWhatsappOptInFlag(e.target.checked)} />
          <Button
            className="form__button"
            onClick={showNextStep}
            btnType="primary"
            size="lg"
            type="button"
          >
            CONTINUE TO NEXT STEP
          </Button>
        </>
      ) : (
        <>
          <WhatsAppOpt onChange={(e, fieldState) => SetWhatsappOptInFlag(e.target.checked)} />
          <Button
            className="form__button"
            onClick={doneAction}
            btnType="primary"
            size="lg"
            type="button"
          >
            DONE
          </Button>
        </>
      )}
    </ContactWrapper>
  );
};

ViewContact.propTypes = {
  user: PropTypes.object,
  id: PropTypes.string,
  role: PropTypes.string,
  recruiter: PropTypes.object,
  stepTwo: PropTypes.array,
  storeCallData: PropTypes.func,
  action: PropTypes.string,
  isVIP: PropTypes.bool,
  changeView: PropTypes.func,
  close: PropTypes.func,
  skipStepTwo: PropTypes.bool,
  setActionState: PropTypes.func,
  fireGa: PropTypes.func,
  getStep2DetailsRequest: PropTypes.func
};

export default ViewContact;
